
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateInteractionNoteDtoFormGroup() {
return new FormGroup({
    interactiontypeId: new FormControl<number | undefined>(1, [Validators.required]),
    containerId: new FormControl<number | undefined>(undefined),
    notes: new FormControl<string | undefined>('', [Validators.required]),
    relationType: new FormControl<string | undefined>('', [Validators.required]),
    relationTypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    visibleForCustomer: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
})
;
}
      